var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.6702H8.5C6.3998 5.6702 5.3497 5.6702 4.54754 6.07893C3.84193 6.43845 3.26825 7.01214 2.90873 7.71774C2.5 8.51992 2.5 9.57002 2.5 11.6702V22.1702C2.5 24.2704 2.5 25.3205 2.90873 26.1227C3.26825 26.8282 3.84193 27.402 4.54754 27.7615C5.3497 28.1702 6.3998 28.1702 8.5 28.1702H19C21.1002 28.1702 22.1502 28.1702 22.9525 27.7615C23.6581 27.402 24.2318 26.8282 24.5913 26.1227C25 25.3205 25 24.2704 25 22.1702V16.9202M9.99996 20.6702H12.0931C12.7046 20.6702 13.0104 20.6702 13.2981 20.6011C13.5531 20.5399 13.797 20.4389 14.0208 20.3019C14.273 20.1472 14.4892 19.931 14.9216 19.4986L26.875 7.5452C27.9105 6.50968 27.9105 4.83074 26.875 3.7952C25.8395 2.75968 24.1605 2.75967 23.125 3.7952L11.1715 15.7486C10.7392 16.181 10.523 16.3972 10.3684 16.6495C10.2313 16.8732 10.1303 17.117 10.069 17.3721C9.99996 17.6599 9.99996 17.9656 9.99996 18.5771V20.6702Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMessage);
export default __webpack_public_path__ + "static/media/create-message.a56ffd7b42694d5407511176bcfefa3c.svg";
export { ForwardRef as ReactComponent };